/*
 * socket-ui.js  (ES5 + jQuery 3, load LAST)
 * Boot + jQuery UI. All networking lives in the other three files.
 *
 * Load order: terminal-socket.js, terminal-pos.js, terminal-device.js, terminal-ui.js
 */
(function (window, $) {
  'use strict';
  var T = window.SocketHub;
  var TOKEN_URL = T.config.tokenUrl;

  function wsUrl() {
    return T.config.url();
  }

  function cartHasItems() {
    return (
      typeof locationCart !== 'undefined' &&
      !!locationCart &&
      ((locationCart.products || []).length > 0 ||
        locationCart.exchange_amount > 0)
    );
  }

  // ---- availability: every terminal is handled on its own ---------------------

  function setTerminalAvailability(id, available) {
    var sel = $.escapeSelector(String(id));
    var $order = $('.order-button[data-terminal-id="' + sel + '"]');
    var $quick = $('.quick-order-button[data-terminal-id="' + sel + '"]');
    var $print = $('.print-btn[data-printer-ip="' + sel + '"]');
    var $retry = $('.retry-btn[data-terminal-id="' + sel + '"]');

    if (available) {
      if (cartHasItems()) {
        $order.prop('disabled', false);
        $quick.prop('disabled', false);
      }
    }
  }

  function refreshAll() {
    var ids = {},
      any = false;
    $.each(T.pos.list(), function (i, t) {
      ids[t.id] = true;
    });
    $('[data-terminal-id]').each(function () {
      ids[String($(this).attr('data-terminal-id'))] = true;
    });
    $.each(ids, function (id) {
      var ok = T.pos.isAvailable(id);
      if (ok) any = true;
      setTerminalAvailability(id, ok);
    });
    // Page-wide controls: usable while AT LEAST ONE terminal is free (the old code toggled them per message)
    var $cancelLast = $('.delete-order-confirm-btn');
    if ($cancelLast.length) {
      $cancelLast.prop('disabled', !any);
      $('#verifone-terminal-not-available-alert').toggleClass('d-none', any);
    }
  }

  // ---- failure UI -------------------------------------------------------------

  function resetSplitUi() {
    if (!$('#payment-split-modal').hasClass('show')) return;
    var $btn = $('#payment-split-button');
    $btn.attr('disabled', false);
    $btn.find('div.loader').remove();
    $btn.text($btn.attr('data-original-text'));
    $('#payment-split-input').attr('disabled', false);
    $('#split-methods-select').attr('disabled', false);
  }

  function markFailed(tx) {
    if (typeof updateOrderProcessStatus === 'function')
      updateOrderProcessStatus(tx.terminalId, 'failed');
    resetSplitUi();
  }

  function paymentNotCompleted(tx, status) {
    if (
      status === T.RESULT.CANCELLED &&
      $('#cancel-last-order-confirm-modal').length > 0
    ) {
      $('#cancel-last-order-confirm-modal').modal('hide');
      showToast({
        message: 'Klarte ikke å avbryte',
        type: 'error',
        position: 'bottom-center',
      });
    }
    if (status === T.RESULT.UNKNOWN) {
      showToast({
        message:
          'Betalingsstatus er ukjent. Kontroller på terminalen før du prøver igjen.',
        type: 'error',
        position: 'bottom-center',
        duration: 6000,
      });
    }
    markFailed(tx);
  }

  function refundNotCompleted(status) {
    var msg =
      status === T.RESULT.UNKNOWN
        ? 'Status for retur er ukjent. Kontroller før du prøver igjen.'
        : 'Ikke klarer å retur !';
    if ($('#cancel-last-order-confirm-modal').length > 0) {
      $('#cancel-last-order-confirm-modal').modal('hide');
      showToast({
        type: 'error',
        message: msg,
        position: 'bottom-center',
        duration: 4000,
      });
    }
    $('.return-order-progress-section').addClass('d-none');
    $('.return-error-message-section').removeClass('d-none');
    $('.return-error-message-section .return-error-message').text(msg);
    $('.return-order-progress-action-btn').prop('disabled', false);
    localStorage.removeItem('verifoneProcessData');
    localStorage.removeItem('verifone_refund_data');
  }

  // ---- success rendering: MOVE your existing code here, unchanged -------------

  /** Paste the body of the old `completed_payment` branch. Needs: data.completedInfo, data.orderProducts, data.redirectUrl.
   *  Drop only the `targetDeviceId !== deviceId` check (the server routes now). */
  function renderPaymentCompleted(data) {
    var completedInfo = (data || {}).completedInfo,
      orderProducts = (data || {}).orderProducts,
      redirectUrl = (data || {}).redirectUrl;

    removeOrderProcessStatus(
      completedInfo.temrinalUniqueId || completedInfo.verifoneSerialNumber
    );

    setTimeout(() => {
      if ($('#externalPaymentProcessModal').hasClass('show')) {
        $('#externalPaymentProcessModal').modal('hide');
      }

      if (completedInfo.orderPaymentSplitId) {
        const splitInput = $(OnDevice.methodSelector('.payment-split-input'));
        const splitButton = $(OnDevice.methodSelector('.order-payment-split'));
        splitButton.find('div.loader').remove();
        splitButton.attr('disabled', false);
        splitInput.attr('disabled', false);
        $('#split-methods-select').attr('disabled', false);
        splitButton.text(splitButton.attr('data-original-text'));
        const paidAmount = parseFloat(splitInput.val());
        splitInput.val('');

        let totalAmount = parseFloat(splitInput.attr('data-max-allowed'));
        const remainingAmout = parseFloat(
          $('#total-amount').attr('data-total-amount')
        );

        const totalPaid = totalAmount - remainingAmout + paidAmount;
        if (totalPaid > 0) {
          const remainingValue = (totalAmount * 100 - totalPaid * 100) / 100;
          $('#total-amount').text(
            `Gjenværende totalt: ${formattedPriceToShow(remainingValue)}`
          );
          $('#total-amount').attr('data-total-amount', remainingValue);

          $('#payment-split-input').attr('data-max-allowed', remainingValue);
        }
      }

      if (
        completedInfo.tableSessionId &&
        $('#table-session-details-modal.show').length > 0 &&
        $('#table-session-details-modal').attr('data-table-session-id') ==
          completedInfo.tableSessionId &&
        $('#btnSyncState').hasClass('d-none')
      ) {
        let isShareByAmount = $('mode-tab[data-mode="sum"]').hasClass('active')
          ? 1
          : 0;

        if (!isShareByAmount) {
          $('#btnSyncState').removeClass('d-none').addClass('d-flex');
        }
      }

      const $confirmationStyle = $('#classic-location-products').data(
        'order-confirmation-toast-style'
      );
      if (completedInfo.posSale && completedInfo.posSale == 2) {
        showToast({
          type: 'success',
          message: 'Veksel vellykket',
          duration: 2000,
        });

        $('#cash-exchange-input').val('');
      } else if (completedInfo.order_html && completedInfo.order_html !== '') {
        $('.confirmation-toast').remove();
        $('#content').append(
          '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
            (window.innerWidth >= 500 ? ' right: 0;' : '') +
            ' width: 480px; display: none;">' +
            '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
            ($confirmationStyle == 'compact' ? 'false' : 'true') +
            '" data-delay="' +
            ($confirmationStyle === 'compact' ? 100000 : 3000) +
            '">' +
            '  <div class="toast-header">' +
            '    <strong class="mr-auto">Ordre registrert</strong>' +
            '    <small></small>' +
            '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
            '      <span aria-hidden="true">&times;</span>' +
            '    </button>' +
            '  </div>' +
            '  <div class="toast-body">' +
            completedInfo.order_html +
            '  </div>' +
            '</div>' +
            '</div>'
        );
      }

      if (
        completedInfo.item_count &&
        completedInfo.total_amount &&
        $confirmationStyle === 'compact'
      ) {
        showPreviousSaleBar(
          completedInfo.item_count,
          completedInfo.total_amount
        );

        if (locationCart.products?.length <= 0) {
          showOrderSuccessCheckmark();
        }
      } else if (completedInfo.order_html && completedInfo.order_html !== '') {
        $('.confirmation-toast').css({ padding: '1rem' }).show();
        $('.confirmation-toast-box')
          .toast('show')
          .on('hidden.bs.toast', function () {
            $('.confirmation-toast').attr('style', function (i, s) {
              return (s || '') + 'padding: 0px !important;';
            });
          });

        if (locationCart.products?.length <= 0) {
          showOrderSuccessCheckmark();
        }
      }

      if (orderProducts && orderProducts.length > 0) {
        const productsWithCount = [];

        orderProducts.forEach((product) => {
          const productDetail = `(${product.quantity})${product.name}`;
          productsWithCount.push(productDetail);
        });

        localStorage.setItem(
          'lastOrderProducts',
          JSON.stringify(productsWithCount)
        );
        localStorage.setItem('lastOrderTotal', completedInfo.total_amount);

        if ($('#payment-split-modal').length) {
          $('#payment-split-modal').modal('hide');

          removeQueryParams('order');
          emptyAllCart('order_complete');
          closePanel();
        }

        setLastOrderDetails();
      }

      if (redirectUrl) {
        document.location.href = redirectUrl;
      }
    }, 1000);
  }

  /** Paste the body of the old `completed_refund` branch. Needs: data.returnedOrderId, data.redirectUrl. */
  function renderRefundCompleted(data) {
    if ($('#cancel-last-order-confirm-modal').length > 0) {
      $('#cancel-last-order-confirm-modal').modal('hide');
    }
    $('.return-order-success-section ').removeClass('d-none');
    $('.return-order-progress-section').addClass('d-none');
    popupAlert();
    setTimeout(() => {
      localStorage.removeItem('verifoneProcessData');
      localStorage.removeItem('verifone_refund_data');

      if (p == 'statistic_order') {
        getAmountOfOrderAndSale(
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod
        );
        $('.modal-backdrop').remove();
      } else if (p == 'today_orders') {
        $('#return-order-progress-modal').modal('hide');
        $(`tr[data-order-id="${data.returnedOrderId}"]`).fadeOut(
          400,
          function () {
            $(this).remove();
          }
        );
        $(`ul[data-order-id="${data.returnedOrderId}"]`).fadeOut(
          400,
          function () {
            $(this).remove();
          }
        );
      } else if (p == 'order_confirmation' && data.redirectUrl) {
        document.location.href = data.redirectUrl;
      }
    }, 1500);
  }

  // payment and availability handlers (bound once, when 'payments' is requested)
  function bindPaymentUi() {
    $(document).on('terminal:terminals', refreshAll);

    $(document).on('terminal:rejected', function (e, d) {
      showToast({
        message:
          d.code === 'terminal_busy'
            ? 'Terminalen er opptatt'
            : 'Terminalen er ikke tilgjengelig',
        type: 'error',
        position: 'bottom-center',
      });
      markFailed(d.tx);
    });

    $(document).on('terminal:result', function (e, r) {
      if (r.kind === 'refund') {
        if (r.status === T.RESULT.SUCCESS) renderRefundCompleted(r.data);
        else refundNotCompleted(r.status);
      } else if (r.status === T.RESULT.SUCCESS) {
        renderPaymentCompleted(r.data);
      } else {
        paymentNotCompleted(r.tx, r.status);
      }
    });
  }

  // print feedback (bound once, when 'print' is requested)
  function bindPrintUi() {
    $(document).on('terminal:status', function (e, m) {
      if (m.state === 'print_rejected' || m.state === 'print_failed') {
        showToast({
          message: 'Utskrift mislyktes',
          type: 'error',
          position: 'bottom-center',
        });
      }
    });

    $(document).on('terminal:print', function (e, job) {
      if (job.state === 'sent' || job.state === 'dispatched') return;

      const texts = {
        busy: 'Terminalen er opptatt. Utskriften ble ikke sendt.',
        not_ready:
          'Terminalen er ikke klar. Åpne betalingsappen på terminalen og prøv igjen.',
        terminal_offline:
          'Terminalen er ikke tilgjengelig. Utskriften ble ikke sendt.',
        unsupported: 'Terminalen støtter ikke utskrift.',
        driver_error: 'Terminalen klarte ikke å skrive ut.',
      };
      const message =
        job.state === 'timeout'
          ? 'Ingen svar fra terminalen. Kvitteringen kan mangle, sjekk før du skriver ut på nytt.'
          : texts[job.reason] || 'Utskrift mislyktes';

      showToast({
        message: message,
        type: 'error',
        position: 'bottom-center',
        duration: 6000,
      });
    });
  }

  // ---- default native bridge (adapts your existing helper) --------------------

  var defaultBridge = {
    start: function (req) {
      try {
        // mirror for existing native-resume code that still reads this key
        localStorage.setItem(
          'verifoneProcessData',
          JSON.stringify({
            type: OnDevice.key() || 'verifone',
            action: req.kind === 'refund' ? 'start_refund' : 'start_payment',
            txId: req.txId,
            paymentData: req.payload,
          })
        );
      } catch (e) {}
      passTerminalDataToWebView(req.payload); // opens the payment application
    },
    print: function (html, segments) {
      // the message differs per on-device solution (PAX prints from segments): see OnDevice.js
      OnDevice.print(html, segments);
    },
  };

  // ---- start the POS channel: from any file, only when needed ----------------------

  var bound = {};
  function bindOnce(name, fn) {
    if (bound[name]) return;
    bound[name] = true;
    fn();
  }

  /**
   * SocketHub.ensurePos(opts)  ->  jQuery promise
   *   opts.features  'all' (default) | 'print' | 'payments' | ['payments','print'] | []
   *   opts.timeout   ms to wait for the connection (default 8000)
   *   opts.deviceId  optional, defaults to localStorage deviceID / body[device_id]
   * Connects once, binds only the UI parts that were asked for, and can be called again
   * later with more features. Rejects with: no_device_id | not_logged_in | replaced | timeout | stopped
   */
  function ensurePos(opts) {
    opts = opts || {};
    var want = T.normalizeFeatures(opts.features);
    // a payment that is still running must be able to finish, whatever this page asked for
    if (T.pos.hasPersistedTxs()) want.payments = true;

    var names = [];
    $.each(want, function (name) {
      names.push(name);
    });

    if (want.payments) bindOnce('payments', bindPaymentUi);
    if (want.print) bindOnce('print', bindPrintUi);

    return T.initPos({
      features: names,
      deviceId: opts.deviceId,
      timeout: opts.timeout,
      reconcile: T.reconcile || null,
    });
  }

  // Exported at load time (not inside $(function () {...})), so other files can call it at once.
  T._installEnsure(ensurePos);
  T.ui = {
    markFailed: markFailed,
    ensurePos: ensurePos,
  };

  // ---- boot: only the pages that need a channel connect ------------------------------

  $(function () {
    var $b = $('body');

    // any on-device solution (Verifone, PAX, ...): the terminal is identified by its unique id
    if (OnDevice.active()) {
      var serial = OnDevice.uniqueId();
      var canServe = function () {
        return (
          !!serial &&
          OnDevice.sessionStarted() &&
          $b.attr('p') === 'payment_standby_mode'
        );
      };
      // connect on the standby screen; READY (visible + session open + idle) is announced separately
      if (serial && $b.attr('p') === 'payment_standby_mode') {
        T.initDevice({
          url: wsUrl(),
          tokenUrl: TOKEN_URL,
          serial: serial,
          bridge: T.bridge || defaultBridge,
          isReady: canServe,
        });
      }
      return;
    }

    var p = $b.attr('p');
    var req = null;
    if (
      p === 'order_confirmation' ||
      p === 'statistic_order' ||
      p === 'today_orders'
    ) {
      req = { features: ['payments', 'print'] }; // refund results; add 'print' here if these pages print
    } else if (p === 'events' && $b.attr('shop_type') === 'pos') {
      // customer screens follow this POS whether or not it has a payment terminal
      req = {
        features: $('[data-terminal-id]').length
          ? ['payments', 'screen']
          : ['screen'],
      };
    } else if (T.pos.hasPersistedTxs()) {
      req = { features: ['payments'] }; // any other page: only to finish a running payment
    } else if (
      $b.attr('data-is-logged-in') === '1' &&
      $b.attr('is_customer_screen') !== '1' &&
      T.config.deviceId()
    ) {
      // every logged-in POS page stays reachable (relay + main); no payment / print / screen UI
      req = { features: [] };
    }

    // the POS page is the only one that publishes: on any other page the customer screen goes back to idle
    var isPosPage = p === 'events' && $b.attr('shop_type') === 'pos';
    if (req && !isPosPage && T.screen) T.screen.resetIfLeft();

    // pages without a logged-in POS device do not touch the websocket at all
    if (req) {
      ensurePos(req).fail(function (code) {
        console.warn('[terminal] POS channel not started:', code);
      });
    }
  });
})(window, jQuery);
